/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.setViewportSize = setViewportSize;
var SET_VIEWPORT_SIZE = 'baltimorebrew.com/page/SET_VIEWPORT_SIZE';

var initialState = {
	isSmallViewport: false,
	isMediumViewport: false,
	isLargeViewport: false
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case SET_VIEWPORT_SIZE:
			{
				return _extends({}, state, {
					isSmallViewport: action.theSize === 'isSmallViewport',
					isMediumViewport: action.theSize === 'isMediumViewport',
					isLargeViewport: action.theSize === 'isLargeViewport'
				});
			}
		default:
			{
				return state;
			}
	}
}

function setViewportSize(theSize) {
	return { type: SET_VIEWPORT_SIZE, theSize: theSize };
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/responsive.js
 ** module id = 268
 ** module chunks = 0
 **/